// src/components/Ajuda/index.js
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { MdClose, MdLink } from 'react-icons/md';
import * as S from './styles';
import HiperlinkService from '../../services/hiperlink/hiperlink.js';

function Ajuda({ isOpen, onClose }) {
  const [helpLinks, setHelpLinks] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Busca os links apenas quando o modal é aberto
    if (isOpen) {
      const fetchHelpLinks = async () => {
        setIsLoading(true);
        try {
          const links = await HiperlinkService.getHiperlinksByFilter({ tipo: 'web' });
          setHelpLinks(links);
        } catch (error) {
          console.error("Erro ao buscar links de ajuda:", error);
          alert("Não foi possível carregar a ajuda. Tente novamente.");
          onClose(); // Fecha o modal em caso de erro
        } finally {
          setIsLoading(false);
        }
      };

      fetchHelpLinks();
    } else {
      // Limpa os links quando o modal é fechado para garantir dados novos na próxima abertura
      setHelpLinks([]);
    }
  }, [isOpen, onClose]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={S.customModalStyles}
      contentLabel="Ajuda"
      appElement={document.getElementById('root')}
    >
      <S.ModalHeader>
        <h2>Ajuda</h2>
        <button onClick={onClose}><MdClose size={24} /></button>
      </S.ModalHeader>
      <S.ModalBody>
        {isLoading ? (
          <p>Carregando...</p>
        ) : (
          helpLinks.length > 0 ? (
            helpLinks.map(item => (
              <S.HelpItem key={item._id}>
                <strong>{item.descricao}</strong>
                <a href={item.link} target="_blank" rel="noopener noreferrer">
                  <MdLink size={16} /> {item.texto}
                </a>
              </S.HelpItem>
            ))
          ) : (
            <p>Nenhum link de ajuda encontrado.</p>
          )
        )}
      </S.ModalBody>
    </Modal>
  );
}

export default Ajuda;